import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FormikField } from '../../../../Formik'
import { SettingsSwitch, SettingsSwitchField } from '../../../../Settings'
import Text from '../../../../Text'
import {
  CALENDAR_SETTINGS_SWITCH_LABEL_KEYS,
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_NOT_FOUND,
} from '../../../CalendarSettings.constants'
import { getCalendarSettingsTaskTypeFieldName } from '../../../CalendarSettings.utils'
import { getIsCalendarSettingsTaskTypesEmpty } from '../TaskTypesField.utils'

import { getCalendarSettingsTaskTypeLabel } from './TaskTypesFieldList.utils'

import * as styles from './TaskTypesFieldList.module.css'

function TaskTypesFieldList({ isScrollable, taskTypes }) {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(styles.TaskTypesFieldList, {
        [styles.scrollable]: isScrollable,
      })}
    >
      {taskTypes.map(type => (
        <FormikField
          Component={SettingsSwitch}
          Field={SettingsSwitchField}
          fieldComponentProps={{
            label: getCalendarSettingsTaskTypeLabel({ t, type }),
          }}
          key={type.id}
          labelKeys={CALENDAR_SETTINGS_SWITCH_LABEL_KEYS}
          name={getCalendarSettingsTaskTypeFieldName(type)}
        />
      ))}
      {getIsCalendarSettingsTaskTypesEmpty(taskTypes) ? (
        <Text
          isSecondary
          className={styles.notFound}
          qaName={QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_NOT_FOUND}
        >
          {t('CalendarSettings.TaskTypesNotFoundKey')}
        </Text>
      ) : null}
    </div>
  )
}

export default TaskTypesFieldList
